var React = require('react');

function MenuClose (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","stroke":"currentColor","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"2.5"},React.createElement("path",{"d":"m1.25 1.25 18 17M1.25 18.25l18-17"})));
}

MenuClose.defaultProps = {"width":"20.5","height":"19.5","data-name":"Layer 1","viewBox":"0 0 20.5 19.5"};

module.exports = MenuClose;

MenuClose.default = MenuClose;
